<div class="p-0">
    <div class="modal-dialog modal-info-panel m-0" role="document">
        <bcu-local-spinner [size]="40" [visible]="(spinner$ | async).visible" *ngIf="(spinner$ | async).visible">
        </bcu-local-spinner>
        <div class="modal-content modal-info-panel"
            *ngIf="(courtBookingDetails$ | async).loaded && (courtBookingDetails$ | async).data as courtBookingDetails">
            <div class="modal-header info-panel-bg-color white">

                <div class="modal-title blocked-slot-info-title d-flex flex-column flex-grow-1">
                    <div class="flex-grow-1 text-right">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="flex-grow-1 text-center">
                        <div class="info-panel-title">
                            {{ courtBookingDetails.categoryOptions.category.code | categoryName }}:
                            {{courtBookingDetails.categoryOptions.name}}
                        </div>
                    </div>
                    <div class="flex-grow-1 text-center mt-1">
                        <div class="info-panel-sub-title" translate>CourtBooking.CourtBookingSubtitle</div>
                    </div>

                </div>

            </div>
            <div class="modal-body p-0 bay-club-light-blue-2-bg">

                <div class="blocked-slot-info-content d-flex flex-column px-3 pt-3 info-panel-bg-color">
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic_bs_calendar"></span></div>
                        <div>{{courtBookingDetails.date | bcDate :"dddd, MMM Do YYYY"}}</div>
                        <div class="flex-grow-1 text-right">
                            <app-court-event-status-pill [infoPanel]="true" [status]="courtBookingDetails.status">
                            </app-court-event-status-pill>
                        </div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic-cb-time"></span></div>
                        <div>{{courtBookingDetails.timeFromInMinutes| timeDisplay}} -
                            {{courtBookingDetails.timeToInMinutes | timeDisplay}}
                        </div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic_bs_court"></span></div>
                        <div>{{courtBookingDetails.court.name}}<span *ngIf="courtBookingDetails.court.tennisType">
                                ({{courtBookingDetails.court.tennisType.name}})</span></div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <hr class="solid bg-white" style="width: 100%;">
                    </div>
                    <div class="flex-grow-1 d-flex" *ngIf="isAnyNote(courtBookingDetails)">
                        <app-court-event-notes-info [notes]="courtBookingDetails.notes"></app-court-event-notes-info>
                    </div>

                    <div class="flex-grow-1 d-flex py-1">
                        <span class="clickable" (click)="onAddNote()">{{'CourtBooking.AddNote' | translate}}</span>
                    </div>

                </div>
                <div class="d-flex flex-column px-3 pb-3 info-panel-bg-color">
                    <div class="d-flex flex-grow-1">
                        <button class="btn btn-grey-outline flex-grow-1 mt-2" (click)="details()"
                            translate>CourtBooking.DetailsButton</button>
                        <button class="btn btn-light-red flex-grow-1 mt-2 ml-2"
                            *ngIf="isCancellationAvailable(courtBookingDetails)" (click)="cancel()"
                            translate>CourtBooking.CancelButton</button>
                        <button class="btn btn-light-red-outline flex-grow-1 mt-2 ml-2" (click)="noShowAll()"
                            *ngIf="isNoShowAvailable(courtBookingDetails)" translate>CourtBooking.NoShowAll</button>
                        <button class="btn btn-light-blue-outline  flex-grow-1 mt-2 ml-2" (click)="checkInAll()"
                            *ngIf="isCheckInAvailable(courtBookingDetails)" translate>CourtBooking.CheckInAll</button>
                    </div>
                </div>
                <div class="d-flex info-panel-players flex-column">
                    <app-player-info *ngFor="let player of courtBookingDetails.players" [player]="player"
                        [courtBooking]="courtBookingDetails" [club]="club$ | async" (playerChanged)="onPlayerChanged()">
                    </app-player-info>
                </div>
            </div>
        </div>
    </div>
</div>